export default function MenuIcon() {
  return (
    <>
      <rect width='18' height='2' rx='1' transform='matrix(-1 0 0 1 19 1)' />
      <rect width='18' height='2' rx='1' transform='matrix(-1 0 0 1 19 9)' />
      <rect width='18' height='2' rx='1' transform='matrix(-1 0 0 1 19 17)' />
    </>
  );
}
